<template>
  <l-marker
    :lat-lng="latLng(item)"
    :zIndexOffset="200"
  >
    <l-icon
      :icon-size="[36, 36]"
      :icon-anchor="[18, 18]"
    >
      <div
          class="icon-car"
          onmouseenter="this.querySelector('.c-map-label-car').style.opacity = '0'"
          onmouseleave="this.querySelector('.c-map-label-car').style.opacity = '1'"
      >
        <div
          class="icon-wrap"
          :style="`transform: rotate(${item.azimuth}deg)`"
        >
          <svg
            :style="`fill: ${color || item.color}`"
            viewBox="0 0 30 36"
            :width="iconSizeAdapter().w"
            :height="iconSizeAdapter().h"
          >
            <use xlink:href="#icon-car-triangle" />
          </svg>
        </div>

        <c-map-label-car 
          :item="item"
          :font_size="font_size"
        />
      </div>
    </l-icon>

    <c-map-tooltip-car
      :offset="offset.tooltipByFontSize(font_size)"
    >
      <c-map-tooltip-car-content 
        :item="item"
        :font_size="font_size"
      />
    </c-map-tooltip-car>

    <c-map-popup-car
      :offset="offset.popupByFontSize(font_size)"
    >
      <c-map-popup-car-content 
        :item="item"
        :font_size="font_size"
      />
    </c-map-popup-car>
  </l-marker>
</template>

<script>
import * as Vue2Leaflet from 'vue2-leaflet'
import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl

import cMapLabelCar from '@/components/map/label/c-map-label-car'
import cMapTooltipCar from '@/components/map/tooltip/car/c-map-tooltip-car'
import cMapTooltipCarContent from '@/components/map/tooltip/car/c-map-tooltip-car-content'
import cMapPopupCar from '@/components/map/popup/car/c-map-popup-car'
import cMapPopupCarContent from '@/components/map/popup/car/c-map-popup-car-content'

import { ClassComputedOffsetByMap } from '@/helpers/base'

export default {
  name: 'c-map-item-car',
  components: {
    'l-marker': Vue2Leaflet.LMarker,
    'l-icon': Vue2Leaflet.LIcon,
    cMapLabelCar,
    cMapTooltipCar,
    cMapTooltipCarContent,
    cMapPopupCar,
    cMapPopupCarContent,
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    color: {
      type: [String, Number],
      default: null
    },
    font_size: {
      type: Number,
      default: 12
    },
    icon_size: {
      type: Object,
      default() {
        return { w: 17, h: 23 }
      }
    },
  },
  data() {
    return {
      offset: new ClassComputedOffsetByMap()
    }
  },
  methods: {
    latLng(obj = { lat: 0, lon: 0 }) {
      return [obj.lat, obj.lon]
    },
    iconSizeAdapter({ w, h } = this.icon_size) {
      return { w: w + 9, h: h + 7 }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/variables';
  .icon-car {
    position: relative;
    display: block;
    width: 36px;
    height: 36px;
    text-align: center;
    .icon-wrap {
      position: relative;
      width: 36px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      &.forward {
        color: $green;
        fill: $green;
      }
      &.backward {
        color: $blue;
        fill: $blue;
      }
    }
  }
</style>